import { render, staticRenderFns } from "./referralCodes.pug?vue&type=template&id=3bad6095&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./referralCodes.scss?vue&type=style&index=0&id=3bad6095&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bad6095",
  null
  
)

export default component.exports